import { formatDateTime, formatRelative } from "@/lib/format";

/** "3 hours ago" with the exact date and time as the title; `empty` when there is no value. */
export function RelativeTime({ value, empty = "Never" }: { value?: string | null; empty?: string }) {
  if (!value) return <span className="text-fg-subtle">{empty}</span>;
  return (
    <time dateTime={value} title={formatDateTime(value)} className="whitespace-nowrap">
      {formatRelative(value)}
    </time>
  );
}
